export const scrollModalTop = () => {
  document.querySelector('.panel-body.scrollable').scrollTop = 0;
};
